module.exports = __webpack_public_path__ + "static/img/pip.7465898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pip.png
// module id = d8FK
// module chunks = 1